export default "__VITE_ASSET__2OKIQ4Dy__"